import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c528e2a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tester-login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "维护测试登录", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请使用已获得本轮维护测试资格的客户账号。登录成功后仍需验证测试资格。", -1))
const _hoisted_4 = {
  key: 0,
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_a_input, {
        "data-operation-error-pattern": "请输入账号和密码",
        "data-operation-error-label": "账号",
        value: _ctx.username,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
        "aria-label": "账号",
        placeholder: "账号",
        autocomplete: "username",
        disabled: _ctx.busy
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_a_input_password, {
        "data-operation-error-pattern": "请输入账号和密码",
        "data-operation-error-label": "密码",
        value: _ctx.password,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        "aria-label": "密码",
        placeholder: "密码",
        autocomplete: "current-password",
        disabled: _ctx.busy
      }, null, 8, ["value", "disabled"]),
      _createVNode(_component_a_button, {
        type: "primary",
        "html-type": "submit",
        loading: _ctx.busy
      }, {
        default: _withCtx(() => [
          _createTextVNode("登录并验证")
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        disabled: _ctx.busy,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回维护页")
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 32),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}